import React from "react"
import styled from "styled-components"

const Title = styled.h1`
  color: #233467;
  text-transform: uppercase;
  margin: ${props => props.margin};
  font-family: "Bellota Text", cursive;
`

const TitleH1 = ({content = "", id = "title", margin = "25px 0"}) => {
    return <Title id={id} margin={margin}>{content}</Title>
}

export default TitleH1
